import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pollFill'
})
export class PollFillPipe implements PipeTransform {
  public transform(rate: number, isFinished: boolean): string {
    const bgColor = isFinished ? '#E9FCF3' : 'var(--primary-30-color)';
    const fgColor = isFinished ? '#A1EBB3' : 'var(--primary-40-color)';

    return `linear-gradient(
      90deg,
      ${fgColor} 0%,
      ${fgColor} ${rate}%,
      ${bgColor} ${rate}%,
      ${bgColor} 100%
    )
    `;
  }
}
